module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-header_header"
  }, [_c('a', {
    attrs: {
      "href": _vm.backUrl
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "back button image"
    }
  })]), _vm._v(" "), _vm._t("headerContent")], 2), _vm._v(" "), _c('h2', {
    staticClass: "page_title"
  }, [_vm._t("headerIcon"), _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-da676054", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da676054"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/page-header.vue
// module id = 816
// module chunks = 0